const parseDate = time => {
  try {
    const d = new Date(time);
    const year = d.getFullYear();
    const month = d.getMonth() + 1; // 0:Jan, 1:Fab ...
    const date = d.getDate();
    const hour = d.getHours();
    const minute = d
      .getMinutes()
      .toString()
      .padStart(2, 0);
    const second = d
      .getSeconds()
      .toString()
      .padStart(2, 0);

    return {
      year,
      month,
      date,
      hour,
      minute,
      second,
    };
  } catch (error) {
    console.warning(error);
    throw error;
  }
};

const monthAbbrivation = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

// Don't need handle i18n here
// DD MMMMM YYYY e.g. 22 Aug 1992
export const abbrivationFormat = time => {
  const { year, month, date } = parseDate(time);

  return `${date} ${monthAbbrivation[month - 1]} ${year}`;
};



// WEBPACK FOOTER //
// ./app/utils/datetime.js